import { loadTimeline, statusBadge } from './maskiner.js';
import { aiDet, curMcId, machines, nulstilDatovalg, selM, selY, setAiDet, setSelM, setSelY } from './state.js';
import { authFetch } from './ui.js';
import { MDA, MFULL } from '../lib/datoer.js';
import { esc } from '../lib/tekst.js';
import { closeModal, toast } from './ui.js';
import { sb } from '../lib/supabase.js';

export function showSvcModal(mcId, name) {
  nulstilDatovalg(mcId);
  document.getElementById('svcSub').textContent=name;
  document.getElementById('stprev').style.display='none';
  document.getElementById('stph').style.display='block';
  document.getElementById('starea').classList.remove('hasimg');
  document.getElementById('aibox').classList.remove('on');
  document.getElementById('dpSec').style.display='block';
  document.getElementById('svcNote').value='';
  document.getElementById('stfile').value='';
  buildDP(); renderSvcLog(mcId);
  document.getElementById('svcModal').classList.add('open');
}

export function buildDP() {
  const mg=document.getElementById('mgrid'), yr=document.getElementById('yrow');
  mg.innerHTML=''; yr.innerHTML='';
  MDA.forEach((m,i)=>{ const b=document.createElement('button'); b.className='mbtn'; b.textContent=m; b.id='mb-'+i; b.onclick=()=>selMo(i); mg.appendChild(b); });
  const now=new Date().getFullYear();
  for(let y=now-3;y<=now;y++){ const b=document.createElement('button'); b.className='ybtn'; b.textContent=y; b.id='yb-'+y; b.onclick=()=>selYr(y); yr.appendChild(b); }
}
export function selMo(i) { setSelM(i); document.querySelectorAll('.mbtn').forEach((b,j)=>b.classList.toggle('sel',j===i)); if(aiDet&&selY!==null) updateAI(); }
export function selYr(y) { setSelY(y); document.querySelectorAll('.ybtn').forEach(b=>b.classList.toggle('sel',parseInt(b.textContent)===y)); if(aiDet&&selM!==null) updateAI(); }
export function updateAI() { if(selM!==null&&selY!==null) document.getElementById('aidate').textContent=MFULL[selM]+' '+selY; }
export function toggleDP() { const s=document.getElementById('dpSec'); s.style.display=s.style.display==='none'?'block':'none'; }

export function handleSticker(e) {
  const file=e.target.files[0]; if (!file) return;
  const reader=new FileReader();
  reader.onload=ev=>{
    const p=document.getElementById('stprev'); p.src=ev.target.result; p.style.display='block';
    document.getElementById('stph').style.display='none';
    document.getElementById('starea').classList.add('hasimg');
    document.getElementById('anov').classList.add('on');
    document.getElementById('dpSec').style.display='none';
    document.getElementById('aibox').classList.remove('on');
    analyzeSticker(ev.target.result.split(',')[1]);
  };
  reader.readAsDataURL(file);
}

export async function analyzeSticker(b64) {
  try {
    const res = await authFetch('/.netlify/functions/analyze-sticker', {
      method: 'POST',
      body: JSON.stringify({ imageData: b64 })
    });
    const data=await res.json();
    document.getElementById('anov').classList.remove('on');
    const text=data.content?.find(b=>b.type==='text')?.text||'';
    let p; try{p=JSON.parse(text.replace(/```json|```/g,'').trim());}catch{stickerFallback();return;}
    setAiDet(true); setSelM(p.month-1); setSelY(p.year);
    document.getElementById('aidate').textContent=MFULL[selM]+' '+selY;
    const c=document.getElementById('aiconf');
    c.textContent=p.confidence==='high'?'✓ Sikker':'⚠ Tjek dato';
    c.className='aiconf '+(p.confidence==='high'?'hi':'lo');
    document.getElementById('aibox').classList.add('on');
    buildDP(); selMo(selM); selYr(selY);
    document.getElementById('dpSec').style.display=p.confidence==='low'?'block':'none';
  } catch { document.getElementById('anov').classList.remove('on'); stickerFallback(); }
}
export function stickerFallback() { document.getElementById('aibox').classList.remove('on'); document.getElementById('dpSec').style.display='block'; toast('⚠ Kunne ikke læse sticker — vælg dato manuelt'); }

export async function saveService() {
  if (selM===null||selY===null) { toast('Vælg måned og år'); return; }
  const date=selY+'-'+String(selM+1).padStart(2,'0')+'-01';
  const note=document.getElementById('svcNote').value.trim();
  const { data: newEntry, error } = await sb.from('service_log').insert({ machine_id:curMcId, service_date:date, note:note||null }).select().single();
  if (error) { toast('❌ '+(error.message||'Fejl')); return; }
  // Opdater lokal cache uden at hente alt igen
  const mc = machines.find(m=>m.id===curMcId);
  if (mc && newEntry) {
    mc._svcLog = [newEntry, ...(mc._svcLog||[])];
    mc._lastSvc = date;
    loadTimeline(curMcId);
    const bdEl=document.getElementById('badges-'+curMcId);
    if (bdEl) bdEl.innerHTML=statusBadge(mc)+(mc.service_plan?`<span class="badge bb">🛡 ${mc.service_plan}-årsplan</span>`:'');
  }
  closeModal('svcModal'); toast('✓ Service registreret: '+MFULL[selM]+' '+selY);
}

export async function renderSvcLog(mcId) {
  const c=document.getElementById('svcLog'); c.innerHTML='<div style="font-size:12px;color:var(--txt-m);padding:4px 0">Henter historik…</div>';
  const { data } = await sb.from('service_log').select('*').eq('machine_id',mcId).order('service_date',{ascending:false});
  if (!data?.length) { c.innerHTML='<div style="font-size:12px;color:var(--txt-m);padding:8px 0">Ingen service registreret endnu</div>'; return; }
  c.innerHTML=data.map((e,i)=>{
    const d=new Date(e.service_date);
    return `<div class="svci"><div class="svcd"></div><div>
      <div class="svcnote">${esc(e.note||'Service')} <span class="svcb ${i===data.length-1?'sbf':'sbr'}">${i===data.length-1?'1. service':'service'}</span></div>
      <div class="svcdstr">${MFULL[d.getMonth()]} ${d.getFullYear()}</div>
    </div></div>`;
  }).join('');
}
